export const filterEmptyStrings = (obj) => {
  return Object.entries(obj).reduce((res, [key, value]) => {
    if (value instanceof File) {
      return { ...res, [key]: value };
    }
    if (Array.isArray(value)) {
      return value.length
        ? {
            ...res,
            [key]: value.map((val) => {
              return val instanceof File ? val : filterEmptyStrings(val);
            }),
          }
        : res;
    }
    if (value && typeof value === "object") {
      return { ...res, [key]: filterEmptyStrings(obj[key]) };
    }
    if (value !== "" && value !== null) {
      return { ...res, [key]: value };
    }
    return res;
  }, {});
};
